import { render, staticRenderFns } from "./Notification-Dialog.vue?vue&type=template&id=588e4a40"
import script from "./Notification-Dialog.vue?vue&type=script&lang=js"
export * from "./Notification-Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588e4a40')) {
      api.createRecord('588e4a40', component.options)
    } else {
      api.reload('588e4a40', component.options)
    }
    module.hot.accept("./Notification-Dialog.vue?vue&type=template&id=588e4a40", function () {
      api.rerender('588e4a40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer-notification/components/Notification-Dialog.vue"
export default component.exports